import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreAddEditTemplateComponent } from './component/store-add-edit-template.component';
import { ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgSelectModule } from '@ng-select/ng-select';
import { FileUploadModule } from 'ng2-file-upload';
import { SharedModule } from '../../../shared/shared.module';



@NgModule({
  declarations: [StoreAddEditTemplateComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    SharedModule,
    FileUploadModule,
    ReactiveFormsModule,
    GoogleMapsModule,
  ],
  exports: [StoreAddEditTemplateComponent]
})
export class StoreAddEditTemplateModule { }
